module.exports = __webpack_public_path__ + "img/270-cancel-circle.3a012681.svg";